import { useEffect, useRef, useState } from 'react';

// To prevent showing a blink of a loader this hook delays the loading
// for specific timeout.

const useDelayedLoading = (realLoading: boolean, timeout: number = 300) => {
  const [delayedLoading, setDelayedLoading] = useState(false);

  const realLoadingRef = useRef(realLoading);

  useEffect(() => {
    // update the ref
    realLoadingRef.current = realLoading;
    // is loading ?
    if (realLoading) {
      setTimeout(() => {
        // still Loading after timeout ?
        if (realLoadingRef.current) {
          setDelayedLoading(true);
        }
      }, timeout);
    } else {
      setDelayedLoading(false);
    }
  }, [realLoading]);
  return delayedLoading;
};

export default useDelayedLoading;
